import React from "react";
// import { FaCheckCircle, FaMoneyBill, FaCalendarAlt } from "react-icons/fa";
// import { IoTime } from "react-icons/io5";
// import membershipPdf from "../assets/docs/docu.pdf";
import { Link } from "react-router-dom";

const memberships = [
  {
    title: "DEFENCE SERVICE OFFICERS",
    description:
      "Both for Serving & Retired officers, Membership Fee - 5,000 tk.",
    price: "৳ 500",
    bg: "bg-[#fdfbf1]",
    hoverBg: "hover:bg-black hover:text-white",
  },
  {
    title: "GOVERNMENT OFFICERS",
    description:
      "For all serving civil government officers, Membership Fee - 1,00,000 tk.",
    price: "৳ 800",
    bg: "bg-[#fdfbf1]", // <- change this from "bg-black text-white"
    hoverBg: "hover:bg-black hover:text-white",
  },
  {
    title: "CIVIL AND OTHERS",
    description: "Any other civil person, Membership Fee - 3,00,000 tk",
    price: "৳ 1200",
    bg: "bg-[#fdfbf1]",
    hoverBg: "hover:bg-black hover:text-white",
  },
  {
    title: "FOREIGNERS",
    description: "For foreigners, Membership Fee - 6,00,000 tk",
    price: "৳ 2000",
    bg: "bg-[#fdfbf1]",
    hoverBg: "hover:bg-black hover:text-white",
  },
  {
    title: "CORPORATE",
    description: "For corporate, Membership Fee - 10,00,000 tk",
    price: "৳ 1500",
    bg: "bg-[#fdfbf1]",
    hoverBg: "hover:bg-black hover:text-white",
  },
];

// const features = [
//   "Minimum Of 2 Golfers",
//   "Tea / Coffee Included",
//   "Discounted Events",
//   "Morning Rolls",
// ];

const Membership = () => {
  return (
    <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
      <h2 className="text-4xl font-bold mb-12 text-center uppercase">
        Membership Fees
      </h2>
      <div className="grid md:grid-cols-2 gap-8">
        {memberships.map((plan, index) => (
          <div
            key={index}
            className={`rounded-xl p-8 transition duration-300 group border border-gray-200 shadow-md hover:shadow-lg ${plan.bg} ${plan.hoverBg}`}
          >
            <h3 className="text-lg font-bold mb-2">{plan.title}</h3>
            <p className="text-sm mb-4">{plan.description}</p>
            <p className="text-4xl font-bold mb-2">
              {plan.price}
              <span className="text-base font-normal text-gray-500">
                /Month
              </span>
            </p>

            {/* <div
              className={`p-4 rounded-xl mb-6 transition duration-300 ${
                plan.bg === "bg-black text-white"
                  ? "bg-[#1c1c1c]"
                  : "bg-white group-hover:bg-[#1c1c1c] group-hover:text-white"
              }`}
            >
              <ul className="space-y-3">
                {features.map((feature, i) => (
                  <li key={i} className="flex items-center gap-2">
                    <FaCheckCircle className="text-lime-500" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div> */}

            <Link
              to="/membership-registration"
              className="bg-lime-400 text-black font-bold px-6 py-2 rounded-full uppercase hover:bg-white transition"
              // onClick={() => window.open(membershipPdf, "_blank")}
            >
              Get Started
            </Link>
          </div>
        ))}
      </div>

      {/* Bottom text */}
      {/* <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-6 text-black text-sm">
        <div className="flex items-center gap-2">
          <span className="text-lime-500">
            <FaCalendarAlt />
          </span>{" "}
          Get 30 day free trial
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lime-500">
            <FaMoneyBill />
          </span>{" "}
          No any hidden fees pay
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lime-500">
            <IoTime />
          </span>{" "}
          You can cancel anytime
        </div>
      </div> */}
    </div>
  );
};

export default Membership;
